
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tylenolautism/privacy-policy",
      function () {
        return require("private-next-pages/tylenolautism/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tylenolautism/privacy-policy"])
      });
    }
  